import {
    HttpResponse,
    FileModel,
    QueryModel,
    RequestParams,
    FileModelIEnumerableApiResultSuccess,
    FileModelApiResultSuccess,
    ApiResultFailed,
    Operation,
    FullRequestParams,
    AggregationModel,
    AggregationResponse,
    GrouppedQueryModel
} from "@/libs/Api";
import ApiService from "@/libs/core/api-service"
import {CrudDataQuery} from '@/libs/core/crud/crud-query';
import {CrudService, CrudListResponse, CrudResponse} from '@/libs/core/crud/crud-service';

export class FilesDataService implements CrudService<FileModel, FileModel> {
    
    getAggregation(query: AggregationModel, params?: RequestParams): Promise<AggregationResponse> {
        throw new Error("Method not implemented.");
    }
    
    getGrouped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        throw new Error("Method not implemented.");
    }
    
    getAll(query: CrudDataQuery<FileModel>): Promise<CrudListResponse<FileModel>> {
        return ApiService.api.getFileBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<FileModel>> {
        return ApiService.api.getFileById(id, params);
    }

    create(item: FileModel, params?: RequestParams): Promise<CrudResponse<FileModel>> {
        throw "NotImplemented";
    }

    update(item: FileModel, params?: RequestParams): Promise<FileModel> {
        return ApiService.api.updateFile(item.id as Required<string>, item, params).then((req: any) => req.data.returnValue);
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<FileModel> {
        return ApiService.api.patchFile(id, patches).then((req: any) => req.data.returnValue);
    }

    delete(query: CrudDataQuery<FileModel>): Promise<CrudListResponse<FileModel>> {
        return ApiService.api.deleteFiles(<any>query.data, query.params).then((req: any) => req.data.returnValue);
    }

    download(query: CrudDataQuery<FileModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        throw "NotImplemented";
    }

}
